import Axios from 'axios'

export default Axios.create({
    baseURL:"https://journal-connect.herokuapp.com/"
})